import { BaseEntity } from './base.entity';

export type DocumentType = 'text' | 'youtube' | 'pdf' | 'image' | 'notion' | 'slack' | 'discord' | 'web' | 'word' | 'excel' | 'ppt' | 'csv';

export class Document extends BaseEntity {
  id: string;
  project_id: string;
  project_sequence_id: number;
  title: string;
  content: string;
  type: DocumentType;
  created_at: Date;
  updated_at: Date;
  created_by_id: string;
  updated_by_id: string | null;
  is_loading?: boolean;
  is_onboarding?: boolean;

  constructor(data: {
    id: string;
    project_id: string;
    project_sequence_id: number;
    title: string;
    content: string;
    type?: DocumentType;
    created_at: Date;
    updated_at: Date;
    created_by_id: string;
    updated_by_id: string | null;
    is_loading?: boolean;
    is_onboarding?: boolean;
  }) {
    super();
    this.id = data.id;
    this.project_id = data.project_id;
    this.project_sequence_id = data.project_sequence_id;
    this.title = data.title;
    this.content = data.content;
    this.type = data.type || 'text';
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.created_by_id = data.created_by_id;
    this.updated_by_id = data.updated_by_id;
    this.is_loading = data.is_loading;
    this.is_onboarding = data.is_onboarding;
    this.setOriginalData(this.toData());
  }


  /**
   * Update document content
   */
  updateContent(title: string, content: string, userId: string): void {
    this.title = title;
    this.content = content;
    this.updated_by_id = userId;
    this.updated_at = new Date();
    this.markAsDirty();
  }


  /**
   * Convert to plain data object
   */
  toData(): any {
    return {
      id: this.id,
      project_id: this.project_id,
      project_sequence_id: this.project_sequence_id,
      title: this.title,
      content: this.content,
      type: this.type,
      created_at: this.created_at,
      updated_at: this.updated_at,
      created_by_id: this.created_by_id,
      updated_by_id: this.updated_by_id,
      is_loading: this.is_loading,
      is_onboarding: this.is_onboarding
    };
  }

  /**
   * Create Document instance from database row
   */
  static fromData(data: any): Document {
    return new Document({
      id: data.id,
      project_id: data.project_id,
      project_sequence_id: data.project_sequence_id,
      title: data.title,
      content: data.content,
      type: data.type,
      created_at: new Date(data.created_at),
      updated_at: new Date(data.updated_at),
      created_by_id: data.created_by_id,
      updated_by_id: data.updated_by_id,
      is_loading: data.is_loading,
      is_onboarding: data.is_onboarding
    });
  }
}

export interface DocumentInsert {
  project_id: string;
  title: string;
  content: string;
  type?: DocumentType;
  created_by_id: string;
  updated_by_id?: string;
}

export interface DocumentUpdate {
  title?: string;
  content?: string;
  type?: DocumentType;
  updated_by_id?: string;
}